import { mainSiteUrl } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div className="flex-1 lg:max-w-[42%]">
            <span className="inline-block text-xs font-medium text-foreground-500 border border-foreground-200 px-3 py-1.5 rounded-full mb-6 tracking-wide">
              About Kakobuy Spreadsheet
            </span>

            <div className="flex items-start gap-8 mb-10">
              <div className="text-right">
                <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">10,000+</div>
                <p className="text-xs text-foreground-500 mt-1">Products Listed</p>
              </div>
              <div className="text-right">
                <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">50,000+</div>
                <p className="text-xs text-foreground-500 mt-1">Active Shoppers</p>
              </div>
            </div>

            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
              What Is Kakobuy
              <br />
              <span className="font-light text-foreground-500 italic">Spreadsheet?</span>
            </h2>

            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                The <strong>Kakobuy Spreadsheet</strong> is a carefully curated product database designed to help savvy shoppers discover trending fashion, accessories, and lifestyle items before they go mainstream. Instead of scrolling endlessly through disorganized product listings, the spreadsheet organizes thousands of verified finds into clear categories — making product discovery faster, smarter, and more efficient.
              </p>
              <p>
                What sets the Kakobuy Spreadsheet apart is its community-driven approach. Every product entry includes real shopper feedback, quality ratings, and direct links, so you never have to guess whether an item is worth buying. Whether you are hunting for the latest sneaker releases, premium hoodies, or hidden accessory gems, the spreadsheet saves you hours of manual searching.
              </p>
              <p>
                Thousands of shoppers rely on Kakobuy Spreadsheet updates every month to stay ahead of trends. New products are added regularly, and curated categories ensure you can jump straight to the items that match your personal style — no fluff, no filler, just the best finds organized in one place.
              </p>
              <p>
                Ready to explore? Visit the main website to access the complete Kakobuy Spreadsheet database and start discovering products that fit your taste and budget.
              </p>
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-primary-600 font-medium text-sm mt-6 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Kakobuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>

          <div className="flex-1 relative hidden lg:block">
            <div className="relative w-full h-[500px]">
              <div className="absolute right-0 top-0 w-[200px] h-[200px] rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.06)]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20with%20large%20monitor%20displaying%20colorful%20data%20charts%20and%20fashion%20mood%20board%20on%20exposed%20brick%20wall%20with%20pinned%20fabric%20swatches%20artistic%20workspace%20aesthetic%20natural%20light%20from%20industrial%20windows%20vibrant%20creative%20energy%20editorial%20photography&width=400&height=400&seq=about-top-small-v2&orientation=squarish"
                  alt="Kakobuy spreadsheet workspace"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute right-0 top-[220px] w-[340px] h-[260px] rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.08)]">
                <img
                  src="https://readdy.ai/api/search-image?query=Product%20unboxing%20flat%20lay%20scene%20with%20tissue%20paper%20packaging%20materials%20and%20new%20fashion%20items%20spread%20across%20rustic%20kraft%20paper%20surface%20excitement%20and%20anticipation%20aesthetic%20overhead%20view%20natural%20morning%20light%20streaming%20in%20warm%20joyful%20tones%20lifestyle%20editorial%20photography&width=680&height=520&seq=about-main-tall-v2&orientation=landscape"
                  alt="Kakobuy product organization"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}